export enum HcSheetView {
  FirstLevel = "first-level",
  SecondLevel = "second-level",
  SecondLevelNbf = "second-level-nbf",
  Navigation = "navigation",
}

interface HcSheetState {
  open: boolean;
  title: string;
  view: HcSheetView;
  secondLevelHeadline: string;
}

type Handler = () => void;

export const hcSheetState = $state<HcSheetState>({
  open: false,
  title: "",
  view: HcSheetView.FirstLevel,
  secondLevelHeadline: "",
});

export function isSecondLevelView(view: HcSheetView): boolean {
  return view !== HcSheetView.FirstLevel;
}

const handlers: { close?: Handler; back?: Handler } = {};

export function onHcSheetClose(handler: Handler): void {
  handlers.close = handler;
}

export function onHcSheetBack(handler: Handler): void {
  handlers.back = handler;
}

export function openHcSheet(title = ""): void {
  hcSheetState.title = title;
  hcSheetState.open = true;
}

export function markHcSheetClosed(): void {
  hcSheetState.open = false;
}

export function setHcSheetSecondLevel(active: boolean, headline = "", nbf = false): void {
  hcSheetState.view = active ? (nbf ? HcSheetView.SecondLevelNbf : HcSheetView.SecondLevel) : HcSheetView.FirstLevel;
  hcSheetState.secondLevelHeadline = active ? headline : "";
}

export function setHcSheetNavigation(active: boolean, headline = ""): void {
  hcSheetState.view = active ? HcSheetView.Navigation : HcSheetView.FirstLevel;
  hcSheetState.secondLevelHeadline = active ? headline : "";
}

export function requestHcSheetClose(): void {
  if (handlers.close) {
    handlers.close();
  } else {
    markHcSheetClosed();
  }
}

export function requestHcSheetBack(): void {
  handlers.back?.();
}
